import React, { useState, useEffect } from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';

import ScoreboardTable from './ScoreboardTable';
import MainMenu from '../../components/MainMenu';
import ScoreboardTableEdit from './ScoreboardTableEdit';
import SMPTitleBar from '../../components/SMP/SMPTitleBar';

import { scorecardStyles } from './styles';

import { getGroupsAndTees } from '../../redux/actions/smp-action/get-groups-and-tees-actions';

const SMPScorecard = () => {
  const classes = scorecardStyles();
  const dispatch = useDispatch();
  const { id: match_id } = useParams();
  const { state } = useLocation();
  const getGroupsAndTeesBody = { match_id, league_id: state?.league_id };

  const groupsAndTeesSelector = useSelector(
    (state) => state.groupsAndTeesReducer
  );

  const [isEdit, setIsEdit] = useState(false);
  const [noOfPlayers, setNoOfPlayers] = useState(0);
  const [handicapDifferential, setHandicapDifferential] = useState(null);

  useEffect(() => {
    if (state?.league_id != null && match_id != null) {
      dispatch(getGroupsAndTees(JSON.stringify(getGroupsAndTeesBody)));
    }
  }, []);

  useEffect(() => {
    if (
      !groupsAndTeesSelector?.loading &&
      !groupsAndTeesSelector?.status?.error &&
      groupsAndTeesSelector?.status?.groupsData?.length > 0
    ) {
      setNoOfPlayers(groupsAndTeesSelector.status.groupsData[0].no_of_players);
      setHandicapDifferential(
        groupsAndTeesSelector.status.groupsData[0].handicap_diffrential
      );
    }
  }, [groupsAndTeesSelector]);

  return (
    <MainMenu>
      <Paper className={classes.mainBox} elevation={3}>
        <SMPTitleBar
          name='Single Match Play'
          handleToggle={() => setIsEdit((prev) => !prev)}
        />

        <Box className={classes.card}>
          <Typography className={classes.boxHeading}>
            SMP - Round of {noOfPlayers}
          </Typography>

          {isEdit ? (
            <ScoreboardTableEdit
              handicapDifferential={handicapDifferential}
              noOfPlayers={noOfPlayers}
              setIsEdit={setIsEdit}
            />
          ) : (
            <ScoreboardTable
              handicapDifferential={handicapDifferential}
              noOfPlayers={noOfPlayers}
            />
          )}
        </Box>
      </Paper>
    </MainMenu>
  );
};

export default SMPScorecard;
